export const preloadedCurrencies = [{ "name": "EURUSD", "desc": "Euro vs US Dollar ", "decimal": 5 }, 
{ "name": "BTCUSD", "desc": "Bitcoin vs US Dollar", "decimal": 2 },
{ "name": "USDJPY", "desc": "US Dollar vs Japanese Yen", "decimal": 3 },
{ "name": "USDCHF", "desc": "US Dollar vs Swiss Franc", "decimal": 5 },
{ "name": "USDCAD", "desc": "US Dollar vs Canadian Dollar", "decimal": 5 },
{ "name": "AUDUSD", "desc": "Australian Dollar vs US Dollar", "decimal": 5 }
]